import { nieswiadomyUmyslChapters } from './content';
export const nieswiadomyUmyslGlossary = nieswiadomyUmyslChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
